import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphQuote = ({ id, entity }) => {
  const quote = entity.getIn(['field_title', 0, 'value']);
  const author = entity.getIn(['field_author', 0, 'value']);

  return (
    <Container id={id} className="Paragraph ParagraphQuote">
      <div className="row">
        <div className="ParagraphQuote__inner col-12 col-md-10 col-lg-8">
          <h3 className="ParagraphQuote__quote">{quote}</h3>
          {author && (
            <p className="ParagraphQuote__author">{author}</p>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphQuote;
